/**
 * `/api/rocketchat` — every call the rocketchat module makes, through core's
 * `apiFetch`.
 */
import type { RocketChatHandleResponse, SetRocketChatHandleRequest } from '@forsys/shared';
import { apiFetch } from '../../api/client';

/** The caller's own. A session is enough. */
export function getOwnHandle(): Promise<RocketChatHandleResponse> {
  return apiFetch<RocketChatHandleResponse>('/rocketchat/me');
}

export function getHandle(userId: number): Promise<RocketChatHandleResponse> {
  return apiFetch<RocketChatHandleResponse>(`/rocketchat/handles/${userId}`);
}

export function setHandle(userId: number, username: string): Promise<RocketChatHandleResponse> {
  const request: SetRocketChatHandleRequest = { username };
  return apiFetch<RocketChatHandleResponse>(`/rocketchat/handles/${userId}`, { method: 'PUT', json: request });
}

export function clearHandle(userId: number): Promise<RocketChatHandleResponse> {
  return apiFetch<RocketChatHandleResponse>(`/rocketchat/handles/${userId}`, { method: 'DELETE' });
}
